import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonDropdownSearchComponent } from 'src/app/common-dropdown-search/common-dropdown-search.component';
import { Token } from 'src/app/manager/token';
import { ContactSupportService } from 'src/app/service/contact-support.service';
import * as moment from 'moment';
import { CommonService } from 'src/app/service/common-service';
import { ResponseHelper } from 'src/app/manager/response.helper';
import { NotificationService } from 'src/app/service/notification.service';
import { environment } from 'src/environments/environment';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { dropDownFields } from 'src/app/manager/dropdown-feilds';
import * as _ from 'lodash';

@Component({
  selector: 'app-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.scss'],
})
export class ContactSupportComponent implements OnInit {
  Title = "Contact Support";

  @ViewChild('fileInputControl') fileInputControl: any;


  formData: FormData = new FormData();
  formFileData: FormData = new FormData();
  uploadedFiles: any[] = [];

  priorityList: any[];
  severityList: any[] = [];

  ticketForm: FormGroup;
  addFieldSetting = {
    idField: 'Client_Id',
    textField: 'Client_Name'
  }
  validated = false;
  clientList: any[] = [];
  userdata;
  UserId: number;
  clientId = "";
  isLoaded = true;
  errorMessage = false;

  defaultColDef;
  columnDefs = [];
  RowSelection = "";
  GridApi;
  GridColumnApi;
  rowData = [];
  workitems: any[] = [];
  ClientId;
  clienterror;
  clientName;

  File;
  Filename = 'No File Chosen';
  FileBase64;
  fileSelected: boolean = true;
  fileSelectedValidated: boolean = false;
  uploadBtnDisable: boolean = true;
  ResponseHelper: ResponseHelper;
  isSubmited = false;
  isDownloaded = false;

  @ViewChild('dropdown') dropdown: CommonDropdownSearchComponent; // common dropdown
  constructor(private fb: FormBuilder, private router: Router,
    private contactSupportService: ContactSupportService,
    public commonService: CommonService,
    private notificationservice: NotificationService)
    {
      this.ResponseHelper = new ResponseHelper(this.notificationservice);
    }

  ngOnInit() {
  this.createFormGroup();

    let token = new Token(this.router);
    this.userdata = token.GetUserData();
    this.UserId = this.userdata.UserId;
    let clientList = [{
      Client_Id: 22,
      Client_Name: "All",
      selected: false
    }];

  //  this.clientList = this.setSelectedDropdown(clientList);
    this.clientList =  this.setSelectedDropdown(this.userdata.Clients);
    console.log(this.clientList);

    if (this.clientList[0].selected == true) {
      // this.showOptionButtons = true;
      this.clientId = this.clientList[0].Client_Id;
    }

    if (this.userdata.Email_Id == null || this.userdata.Email_Id == "undefined") {
      this.ticketForm.get('CreatedBy').setValue('');
  }
  else {
      this.ticketForm.get('CreatedBy').setValue(this.userdata.Email_Id);
      this.ticketForm.get('CreatedBy').disable();
  }

    this.priorityList = [
      { id: 1, name: '1 - Highest' },
      { id: 2, name: '2 - Medium' },
      { id: 3, name: '3 - Low' },
      { id: 4, name: '4 - Lowest' }
  ];

  this.severityList = [
      { id: 1, name: '1 - Critical' },
      { id: 2, name: '2 - High' },
      { id: 3, name: '3 - Medium' },
      { id: 4, name: '4 - Low' }
  ];

  // this.createFormGroup();
    this.getColumnList();
    if(this.clientList)
    {
      this.getWorkItems(this.clientList[0]['Client_Name']);
    }
  }

  // create form for ticket
  createFormGroup() {
    this.ticketForm = this.fb.group({
      Title: ['', [Validators.required,Validators.minLength(1)]],
      Severity: ['', Validators.required],
      Priority: ['', Validators.required],
      Description: ['',[ Validators.required,Validators.minLength(1)]],
      CreatedBy: ['', [Validators.required, Validators.email]],
      Uploadedfile: ['']
    });
  }

  // client list selected
  setSelectedDropdown(data) {
    if (data && data.length >= 1) {
      data[0].selected = false;
      return data;
    } else {
      data[0].selected = true;
      return data;
    }
  }

  // ag-grid on grid ready
  onGridReady(event) {
    event.api.sizeColumnsToFit()
    //event.api.sizeColumnsToFit()
    this.GridApi = event.api;
    this.GridColumnApi = event.columnApi;
    setTimeout(function () {
      event.api.resetRowHeights();
    }, 500);
  }

  // ag-grid get column list
  getColumnList(){
    this.columnDefs = [
      { headerName: 'Ticket', field: 'id', cellRenderer: this.ActionCellNavigateToJiraTicket,
      cellStyle: { cursor: 'pointer' }, width:130},
      { headerName: 'Status', field: 'state', width:150 },
      { headerName: 'Priority', field: 'priority' },
      { headerName: 'Severity', field: 'severity' },
      { headerName: 'Summary', field: 'title',cellClass: "cell-wrap-text",
        autoHeight: true, cellStyle: { 'white-space': 'normal' }, width: 300,
      },
      { headerName: 'Description', field: 'description', cellClass: "cell-wrap-text",
        autoHeight: true, cellStyle: { 'white-space': 'normal' }, width: 400,
        cellRenderer: this.ActionCellRendererClassDescription,
      },
      { headerName: 'Logged By', field: 'loggedBy' },
      { headerName: 'Created On', field: 'createdDate' },
      { headerName: "Download Attachment", field: "id", width: 200,
       cellRenderer: this.ActionCellRendererClassAttachment, cellStyle: { cursor: 'pointer',textAlign: 'center' } },
    ]

    this.RowSelection = 'multiple';
  }

  // action cell renderer for download
  ActionCellNavigateToJiraTicket(params) {
    let val
    let eDiv = document.createElement('div');

    val = params.value
    eDiv.innerHTML = '<a class="">' + params.value + '</a>';

    return eDiv;
  }

    // action cell renderer for download
    ActionCellRendererClassAttachment(params) {
      let val
      let eDiv = document.createElement('div');
      // if (!params.value) {
      val = params.value
      eDiv.innerHTML = '<a class=""><i class="fa fa-download"></i></a>';
      // }
      return eDiv;
    }

    ActionCellRendererClassDescription(params) {
      let val
      let eDiv = document.createElement('div');
      if (params.value) {
      val = params.value;

      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const urls = val.match(urlRegex);
      console.log(urls);

      if(urls){
        // Iterate over the matched URLs
        urls.forEach(url => {
          // Create an anchor element with the URL
          const anchor = `<a href="${url}" target="_blank">${url}</a>`;
          val = val.replace(url, anchor);
        });
      }
      eDiv.innerHTML = val;
      }
      return eDiv;
    }

    // ag-grid on cell clicked
  onCellClicked(data) {
    let id = data.data.id;
    if(data.colDef.headerName == 'Download Attachment'){
      this.isDownloaded = true;
      this.contactSupportService.getAttachment(id,this.contactSupportService.projectName).subscribe(res=> {
        this.downloadAttachment(res);
      }, err =>{
        this.ResponseHelper.GetFaliureResponse(err);
      })
    } else if(data.colDef.headerName == 'Ticket'){
      this.navigateToJiraTicket(id);
    }
  }

  // when click on Ticket navigate to jira ticket - gebbs service desk
  navigateToJiraTicket(id: number) {
    const baseUrl = environment.gebbsServiceDesk;
    const queryParams = `id=${id}&user=${encodeURIComponent(this.userdata.Email_Id)}`;
    const url = `${baseUrl}?${queryParams}`;
    window.open(url, '_blank');
}

  // Upload files functionality
  changeListener(event): void {
    this.formFileData = new FormData();
    var newArray = [];

    if (event.target.files && event.target.files.length > 0) {
      for (let file of event.target.files) {
        let fileExists = this.uploadedFiles && this.uploadedFiles.some(s => s.name == file.name);
        if (!fileExists) {
            this.formFileData.append('files', file);
            newArray.push(file);
            if (!this.uploadedFiles) {
                this.uploadedFiles = [];
            }
            this.uploadedFiles.push(file);
        }
      }
      // this.ConvertToBase64();
    }
    else {
      this.Filename = 'No File Chosen';
      this.File = null;
      this.fileSelectedValidated = true;
      this.FileBase64 = null;
      this.uploadedFiles = [];
      this.ticketForm.get('Uploadedfile').setValue('');
    }
  }

  removeFile() {
    this.uploadedFiles = [];
    this.ticketForm.get('Uploadedfile').setValue('');

    // const removedFile = event;
    // const index = this.uploadedFiles.findIndex(file => file.name === removedFile.name);
    // if (index !== -1) {
    //     const formDataFiles = this.formFileData.getAll('files');
    //     const updatedFiles = formDataFiles.filter((file: any) => file.name !== removedFile.name);
    //     this.formFileData.delete('files');
    //     updatedFiles.forEach((file: any) => this.formFileData.append('files', file));
    // }
}

  ConvertToBase64() {
    let reader = new FileReader();
    reader.readAsDataURL(this.File);
    reader.onload = () => {
      this.FileBase64 = reader.result.toString().split(',')[1];
    }
  }


  // submit to create jira ticket
  onSubmit() {
    this.validated = true;
    this.isSubmited = true;

    this.formData = new FormData();
    this.formData.append('ClientName', this.dropdown.activeUserList[0].Client_Name);
    this.formData.append('CreatedBy', this.ticketForm.get('CreatedBy').value);
    this.formData.append('Title', this.ticketForm.get('Title').value);
    this.formData.append('Description', this.ticketForm.get('Description').value);
    this.formData.append('Priority', this.ticketForm.get('Priority').value);
    this.formData.append('Severity', this.ticketForm.get('Severity').value);
    this.formData.append('ProjectName', this.contactSupportService.projectName);

    for (let file of this.uploadedFiles) {
      this.formData.append('files', file);
    }
    console.log(this.formData);

    if (this.ticketForm.valid) {
      this.contactSupportService.createWorkItems(this.formData).subscribe((res:any) =>{
        console.log(res);
        if(res != null){
          this.isSubmited = false;
          this.onClear();

          // var SelectedCLient =  _.filter(this.userdata.Clients, { "Client_Name": this.dropdown.activeUserList[0].Client_Name });
         // this.onClientChange(SelectedCLient);
          //this.dropdown.activeUserList;
          // this.setSelectedDropdown(this.userdata.Clients);

          this.getWorkItems(this.dropdown.activeUserList[0].Client_Name);

          let data = [{ Message: 'Ticket <b>' + res.id + '</b> is created.', Type: "SUCCESS" }]
          this.notificationservice.ChangeNotification(data)
        }
      }, err=>{
        this.ResponseHelper.GetFaliureResponse(err);
      })
    } else {
      // Form is invalid, handle validation errors
      console.log('Form is invalid');
    }
  }

  // clear form
  onClear() {

    this.ticketForm.get('Severity').setValue('');
    this.ticketForm.get('Priority').setValue('');
    this.ticketForm.get('Title').setValue('');
    this.ticketForm.get('Description').setValue('');
    this.ticketForm.get('Uploadedfile').setValue('');

    // this.ticketForm.reset();
   // this.dropdown.activeUserList = [];
    this.validated = false;
    this.formData.delete('ClientName');
    this.formData.delete('CreatedBy');
    this.formData.delete('Title');
    this.formData.delete('Description');
    this.formData.delete('Priority');
    this.formData.delete('files');
    this.formData.delete('Severity');
    this.uploadedFiles = [];
  }

  // get jira ticket details
  async getWorkItems(clientName) {
    // let clientName = JSON.parse(sessionStorage.getItem('ClientId')).clientName;
    // this.clientName = this.clientList[0]['Client_Name'];
    this.rowData = null;
    if (this.clientName) {
       this.isLoaded = true;
      this.contactSupportService.getWorkItems(clientName, this.contactSupportService.projectName).subscribe({
        next: (response: any) => {
          if (response) {
            const priorityMap = { '1': 'Highest', '2': 'Medium', '3': 'Low', '4': 'Lowest' };
            const severityMap = { '1 - Critical': 'Critical', '2 - High': 'High', '3 - Medium': 'Medium', '4 - Low': 'Low' };

            response.forEach(item => {
              const priority = item.fields['Microsoft.VSTS.Common.Priority'];
              const severity = item.fields['Microsoft.VSTS.Common.Severity'];
              if (priority in priorityMap) {
                item.fields['Microsoft.VSTS.Common.Priority'] = priorityMap[priority];
              }
              if (severity in severityMap) {
                item.fields['Microsoft.VSTS.Common.Severity'] = severityMap[severity];
              }
              item.fields['System.CreatedDate'] = moment(new Date(item.fields['System.CreatedDate'])).format("MM/DD/YYYY");

              item['state'] = item.fields['System.State'];
              item['priority'] = item.fields['Microsoft.VSTS.Common.Priority'];
              item['loggedBy'] = item.fields['System.CreatedBy'].displayName;
              item['createdDate'] = item.fields['System.CreatedDate'];
              item['title'] = item.fields['System.Title'];
              item['description'] = item.fields['System.Description'];
              item['severity'] = item.fields['Microsoft.VSTS.Common.Severity'];
            });

            this.rowData = response;
            console.log(this.rowData, 'rowdata');

            this.isLoaded = false;
            this.getColumnList();

            // this.filterColumnsListRFC = this.utilis.getFilterSelectColoumn(this.workitems);
          }
        },
        error: (error) => {
          console.error('Error occurred:', error);
        },
      });
    } else {
        this.isLoaded = false;
    }
}


// on client change
onClientChange(event) {
  this.clienterror = false;
  this.clientName = event?.Client_Name
  if (!event?.Client_Id || event?.Client_Id == "") {
    this.ClientId = null;
    this.clientName = null;
    this.rowData = null;
  }
  else {
    this.clientName = event?.Client_Name;
    this.ClientId = event?.Client_Id;
    console.log(this.clientName, 'this.clientName');
      this.getWorkItems(this.clientName);
  }
}

// ag-grid download attachment from column
downloadAttachment(response){
  const files = response.body;
  if (files != null) {
      files.map((file: any) => {
          const fileName = file.fileDownloadName;
          const contentType = file.contentType;
          const fileContents = atob(file.fileContents);

          const byteArray = new Uint8Array(fileContents.length);
          for (let i = 0; i < fileContents.length; i++) {
              byteArray[i] = fileContents.charCodeAt(i);
          }
          const blob = new Blob([byteArray.buffer], { type: contentType });

          const downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = fileName;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
      });
      this.isDownloaded = false;
      let data = [{ Message: "Attachments downloaded successfully.", Type: "SUCCESS" }]
      this.notificationservice.ChangeNotification(data)
  } else {
    this.isDownloaded = false;
    let data = [{ Message: "No attachments available.", Type: "info" }]
    this.notificationservice.ChangeNotification(data)
  }
}

 // Method to handle file dropping
 drop(event: CdkDragDrop<File[]>) {
  const droppedFiles: File[] = event.previousContainer.data;
  // Append dropped files to the existing files in your form control
  this.ticketForm.get('Uploadedfile').setValue([...droppedFiles, ...event.container.data]);
}

}
